<app-container>
  <mat-card>
    <mat-card-content>
      <h1 class="text-center">Sign In</h1>
      <form [formGroup]="form" (ngSubmit)="login()" mat-card-content>
        <div class="grid gap-md w-1/2 mx-auto m-1xl">
          <div>
            <label>Email Address</label>
            <mat-form-field class="w-full">
              <input
                matInput
                type="email"
                autocomplete="email"
                aria-describedby="emailHelp"
                placeholder="Email"
                formControlName="email"
              />
              <mat-error
                *ngIf="
                  error &&
                  (error.code === errorCodes.username_doesnt_exist || error.code === errorCodes.missing_username)
                "
              >
                {{ error.message }}
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <label for="password">Password</label>
            <mat-form-field class="w-full">
              <input
                matInput
                type="password"
                class="form-control text-center"
                id="password"
                autocomplete="password"
                placeholder="Password"
                formControlName="password"
              />
              <mat-error
                *ngIf="
                  error && (error.code === errorCodes.missing_password || error.code === errorCodes.wrong_password)
                "
              >
                {{ error.message }}
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <a [routerLink]="['/auth/forgot-password']">Forgot Password</a>
          </div>

          <div class="form-group text-center mt-5">
            <button class="btn btn-primary">
              Sign In
            </button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</app-container>
